export default function IosRecording() {
  return (
    <div
      className="ion-icon-ios-recording"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<path d="M386.2,144c-60.6,0-109.8,49.9-109.8,111.8c0,40.4,21,76.2,52.5,95.2H183.1c31.5-19,52.5-54.8,52.5-95.2
		c0-61.9-49.2-111.9-109.8-111.9C65.2,143.9,16,194.1,16,255.9C16,317.8,65.2,368,125.8,368h260.4c60.6,0,109.8-50.1,109.8-112
		C496,194.1,446.8,144,386.2,144z M128,320c-35.3,0-64-28.7-64-64c0-35.3,28.7-64,64-64s64,28.7,64,64C192,291.3,163.3,320,128,320z
		 M384,320c-35.3,0-64-28.7-64-64c0-35.3,28.7-64,64-64s64,28.7,64,64C448,291.3,419.3,320,384,320z"/>
	<path d="M384,208c-26.5,0-48,21.5-48,48c0,26.5,21.5,48,48,48s48-21.5,48-48C432,229.5,410.5,208,384,208z"/>
	<path d="M128,208c-26.5,0-48,21.5-48,48c0,26.5,21.5,48,48,48s48-21.5,48-48C176,229.5,154.5,208,128,208z"/>
</g>
</svg>
`,
      }}
    />
  )
}
